module.exports = __webpack_public_path__ + "img/data.488ac88d.svg";